// extracted by mini-css-extract-plugin
export default {"container":"style_container__MFVnG","iconContainer":"style_iconContainer__KR4qa","text":"style_text__xUVEF"};